<template>
    <w-table
        v-bind="$attrs"
        :headers="headers"
        :items="items"
        :loading="loading"
        class="custom-table"
    >
        <template v-for="(_, slotName) in $slots" v-slot:[slotName]="slotData">
            <slot :name="slotName" v-bind="slotData" />
        </template>

        <template #no-data> Tiada maklumat untuk dipaparkan </template>
    </w-table>
</template>

<script>
import { computed } from "@vue/reactivity";
import { ref, defineComponent, onMounted, watch } from "vue";

export default defineComponent({
    props: {
        title: String,
        perPageOption: {
            type: Array,
            default: [
                { label: "5", value: 5 },
                { label: "10", value: 10 },
                { label: "50", value: 50 },
                { label: "100", value: 100 },
            ],
        },
        headers: [Array, Object],
        items: [Array, Object],
        loading: false,
    },
});
</script>

<style>
.custom-table > table.w-table {
    border-collapse: separate;
}

.custom-table > table.w-table > thead > tr > th.w-table__header {
    color: #fff;
    background-color: #070c4a;
    font-size: 12px;
    text-transform: uppercase;
    padding: 10.2px 6px;
    font-weight: bold;
}

.custom-table.w-table-wrap {
    border: none !important;
    padding: 0;
}

.custom-table > table.w-table > thead > tr > th.w-table__header--sortable {
    cursor: unset !important;
    pointer-events: none !important;
}

.custom-table > table > thead > tr > th > i {
    display: none;
}
</style>
